import desktopBg from '@app/ahava/assets/desktop-bg.jpg';
import mobileBg from '@app/ahava/assets/mobile-bg.jpg';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import emotionReset from 'emotion-reset';

export const globalStyles = (isDev: boolean,) => css`
  ${isDev && emotionReset}
  
  html, body {
    background: url(${desktopBg}) center center no-repeat;
    background-size: cover;
    ${isDev && `
      height: 100%;
    `}
    
    @media (max-width: 768px) {
      background: url(${mobileBg}) center center no-repeat;
      background-size: cover;
    }
  }
  
  #saywhatt-page {
    height: 100dvh;
    width: 100%;
    padding: 0 56px;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0;
    }
    
   ${isDev && `
      height: 100%;
      
      #saywhatt-outlet {
        height: 100%;
      }
  `}
    
    * {
      box-sizing: border-box;
    }
  }

  footer {
    display: none;
  }
`;

export const AppWrapper = styled.div<{ isChatOpen: boolean }>`
  height: 100%;
  padding: 100px 0 40px 0;
  font-family: "Benton Sans";
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: ${({ isChatOpen }) => isChatOpen ? '0' : '40px 15px 40px'};
    flex-direction: column;
    justify-content: ${({ isChatOpen }) => isChatOpen ? 'flex-end' : 'flex-start'};
    min-height: calc(100dvh - 77px);
  }
`;

export const AppContent = styled.div`
  max-width: 810px;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 0;
    height: auto;
  }
`;

export const FooterText = styled.p`
  margin-top: 20px;
  color: whitesmoke;
  font-size: 15px;
  letter-spacing: 0.01rem;
  justify-content: center;

  a {
    color: whitesmoke;
  }

  @media (max-width: 768px) {
    position: absolute;
    top: 20px;
    left: 15px;
    right: 15px;
    text-align: center;
  }
`;